interface EditorSectionLargeTitleProps {
    title: string;
    padding?: string;
}

export const EditorSectionLargeTitle: React.FC<EditorSectionLargeTitleProps> = ({
    title,
    padding = 'pl-4',
}): JSX.Element => <h1 className={`text-xl ${padding} font-extrabold capitalize text-white`}>{title}</h1>;

interface EditorSectionTitleProps {
    title: string;
    padding?: string;
    height?: string;
}

export const EditorSectionTitle: React.FC<EditorSectionTitleProps> = ({
    title,
    padding = '',
    height = 'h-8',
}): JSX.Element => (
    <h1 className={`flex ${padding} ${height} items-center text-sm font-extrabold capitalize text-white `}>{title}</h1>
);
